import React, { useEffect, useState } from "react";
import nodata from "../../assets/images/no-data.png";

function ExtractedDataListing({ responseData }) {
 
  return (
    <div className="extracted_data_section pb-3 overflow-auto scrollbar1 px-0 px-md-3 px-md-0 position-relative">
      <div className="pt-3 pt-md-0">
        <h2 className="font_16  fw-bold mb-3 text-center pt-2 mb-2">
          Extracted data
        </h2>
      </div>

      <div className="px-3  pt-3 pb-1 font_13">
        <div className="">
          <div className="row">
            <div className="col-12">
              {(responseData || Object.keys(responseData).length !== 0) && (
                <div className="row mb-2 d-none d-md-flex">
                  <div className="col-6">
                    <h2 className="font_18 font_600">Fields</h2>
                  </div>
                  <div className="col-6">
                    <h2 className="font_18 font_600 ">Values</h2>
                  </div>
                </div>
              )}
            </div>
            {(responseData || Object.keys(responseData).length !== 0) ? (
                Object.entries(responseData).map(([key, value, index]) => (
                <div
                  key={index}
                  className="col-12 py-2 document_values pb-0 pb-sm-2"
                >
                  <div className="row">
                    <div className="col-12 font_500 col-md-6 text_gray8  text-capitalize">
                      {key}
                    </div>
                    <div className="col-12 col-md-6 pt-1 pt-sm-0 mb-3 mb-sm-0">
                      <div className="d-flex justify-content-start ">
                        <span className="text_master2 fw_600 word_break text-start ">
                          {value}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="d-flex flex-column align-items-center mt-0 mt-md-5">
                <img
                  src={nodata}
                  className="no_data_thumbnail object_fit_contain"
                />
                <h4 className="text_gray7 font_16 mt-3">
                  {" "}
                  Unable To Process Data
                </h4>
              </div>
            )}
           
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExtractedDataListing;
